import PropTypes from 'prop-types';
import { TRANSLATION_PREFIX } from '../../consts';

export const IMPORT_MODAL_PREFIX = `${TRANSLATION_PREFIX}.IMPORT_MODAL`;

export const importResultShape = PropTypes.shape({
    status: PropTypes.oneOf(['success', 'error']).isRequired,
    fileName: PropTypes.string,
    message: PropTypes.string,
    rowsImported: PropTypes.number,
    totalRows: PropTypes.number,
    errorRows: PropTypes.number,
    totalErrors: PropTypes.number,
    errors: PropTypes.arrayOf(PropTypes.object),
});
